import Button from "../../../../Custom/Button/Button";
import DodavanjeOstaleOpreme from "./DodavanjeOstaleOpreme";
import PretragaOstaleOpreme from "./PretragaOstaleOpreme";
import { useEffect, useState } from "react";

function OstalaOpremaPocetna() {
  // "" - pocetna, "dodavanje", "pretraga"
  const [currentState, setCurrentState] = useState("");

  // "AKTIVNA" | "ARHIVIRANE" | "TUDJE"
  const [selectedView, setSelectedView] = useState("AKTIVNA");

  const handleClickDodavanje = () => {
    setCurrentState("dodavanje");
  };

  const handleClickPretraga = () => {
    setCurrentState("pretraga");
  };

  // Klik na “prikaz” samo šalje signal glavnom prozoru + utisne dugme
  const setView = (mode) => {
    setSelectedView(mode);
    window.dispatchEvent(
      new CustomEvent("machinesViewChange", {
        detail: { mode },
      }),
    );
    setCurrentState("");
  };

  // Sinhronizacija: kad glavni prozor promeni view (npr. preko NAZAD),
  // ovde se automatski “utisne” odgovarajući taster
  useEffect(() => {
    const onSync = (e) => {
      const mode = e?.detail?.mode;
      if (mode === "AKTIVNA" || mode === "ARHIVIRANE" || mode === "TUDJE") {
        setSelectedView(mode);
      }
    };

    window.addEventListener("machinesViewSync", onSync);
    return () => window.removeEventListener("machinesViewSync", onSync);
  }, []);

  return (
    <>
      {currentState === "" && (
        <div style={{ width: "100%" }}>
          <div onClick={handleClickDodavanje}>
            <Button
              activation={true}
              style={{ padding: "10px", fontWeight: "bold", textAlign: "left" }}
            >
              ДОДАВАЊЕ КОЛЕКТИВНЕ ОПРЕМЕ
            </Button>
          </div>

          <div onClick={handleClickPretraga}>
            <Button
              activation={true}
              style={{ padding: "10px", fontWeight: "bold", textAlign: "left" }}
            >
              ФИЛТРИРАЊЕ КОЛЕКТИВНЕ ОПРЕМЕ
            </Button>
          </div>

          <div onClick={() => setView("AKTIVNA")}>
            <Button
              active={selectedView === "AKTIVNA"}
              style={{ padding: "10px", fontWeight: "bold", textAlign: "left" }}
            >
              АКТИВНА КОЛЕКТИВНА ОПРЕМА
            </Button>
          </div>

          <div onClick={() => setView("ARHIVIRANE")}>
            <Button
              active={selectedView === "ARHIVIRANE"}
              style={{ padding: "10px", fontWeight: "bold", textAlign: "left" }}
            >
              АРХИВИРАНА КОЛЕКТИВНА ОПРЕМА
            </Button>
          </div>
        </div>
      )}

      {currentState === "dodavanje" && (
        <DodavanjeOstaleOpreme setCurrentState={setCurrentState} />
      )}

      {currentState === "pretraga" && (
        <PretragaOstaleOpreme onClose={() => setCurrentState("")} />
      )}

      {/* <div className="masine-uredjaji-notifikacije">
        OVDE IDU NOTIFIKACIJE
      </div> */}
    </>
  );
}

export default OstalaOpremaPocetna;